<template>
    <div>
        <div class="mb-4">
            <router-link :to="{ name: 'categories' }">
                <h3>&larr; Back to categories</h3>
            </router-link>
        </div>

        <div class="mb-4" :class="{ invisible: !this.initializedForm }">
            <h1 v-if="!isEdit" class="mt-2 mb-4 font-sans text-n-gray-dark">Add Category</h1>
            <h1 v-else class="mt-2 mb-4 font-sans text-n-gray-dark">Edit Category</h1>

            <div class="flex flex-wrap">
                <div class="w-full mb-3 md:mb-0 md:pr-5">
                    <label for="title" class="sr-only">Enter category name</label>
                    <input
                        id="title" type="text" name="title"
                        placeholder="Enter category name"
                        v-model="form.title" />
                </div>
                <div class="w-full mb-3 md:mb-0 md:pr-5 pt-2">
                    <label for="slug" class="sr-only">Enter category slug from Craft</label>
                    <input
                        id="slug" type="text" name="slug"
                        placeholder="Enter category slug from Craft"
                        v-model="form.slug" />
                </div>

                <div class="w-full mb-3 md:mb-0 md:pr-5 pt-2">
                    <label for="category-group" class="sr-only">Select Category Group</label>
                    <select :class="{ placeholder: form.category_group_id === null }" id="category-group" v-model="form.category_group_id">
                        <option value="" disabled>-- Select Category Group --</option>
                        <option v-for="group in categoryGroups" :value="group.id" :key="group.id">
                            {{ group.title }}
                        </option>
                    </select>
                </div>

                <div class="w-full md:w-1/4 pt-2 pb-4">
                    <button type="button" class="button w-full" @click="saveCategory">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
    name: 'CategoryCreateEdit',
    title: 'Category Create/Edit',
    props: {
        id: {
            required: false,
            type: [Number, String],
            default: 0,
        }
    },
    data() {
        return {
            form: {
                title: '',
                slug: '',
                category_group_id: '',
            },
            saving: false,
            initializedForm: this.isEdit,
        };
    },
    computed: {
        ...mapGetters({
            categoriesById: 'categoriesById',
            categoryGroups: 'categoryGroups'
        }),
        isEdit() {
            return !!this.id
        }
    },
    watch: {
        id() {
            this.initializeForm()
        },
        categoriesById() {
            this.initializeForm()
        }
    },
    methods: {
        initializeForm() {
            this.initializedForm = false

            if(! this.id) {
                this.initializedForm = true
                return;
            }

            let category = this.categoriesById[this.id]

            if (!category) return;

            this.form.category_group_id = null
            this.form.title = category.title
            this.form.slug = category.slug

            if (category.category_group) {
                this.form.category_group_id = category.category_group.id
            }

            this.$nextTick(() => {
                this.initializedForm = true
            })
        },
        saveCategory() {

            this.saving = true

            if (this.isEdit) {
                let route = this.$laroute.route('api.categories.update', { category: this.id } )

                axios.put(route, this.form ).then(_ => {
                    this.$toasted.show('Category has been updated')
                    this.$router.push({ name: 'categories' })
                    this.clearSave()
                })
            } else {
                let route = this.$laroute.route('api.categories.store')

                axios.post(route, this.form).then(_ => {
                    this.$toasted.show('Category has been added')
                    this.$router.push({ name: 'categories' })
                    this.clearSave()
                })
            }

        },
        clearSave() {
            this.$store.dispatch('getCategories')
            this.saving = false
            this.form.title = ''
            this.form.slug = ''
            this.form.category_group_id = ''
        }
    },
    mounted() {
        this.$store.dispatch('getCategories')
    }
}
</script>
